import type React from 'react';
import { initials as toInitials } from '@/lib/format';
import './Avatar.scss';

export interface AvatarProps {
  name: string;
  colour: string;
  /** Diameter in pixels. Font size scales with it, as in the design. */
  size?: number;
  className?: string;
}

export const Avatar: React.FC<AvatarProps> = ({ name, colour, size = 40, className = '' }) => (
  <div
    className={`avatar ${className}`.trim()}
    style={{
      width: size,
      height: size,
      background: colour,
      fontSize: Math.round(size * 0.34),
    }}
    aria-hidden="true"
  >
    {toInitials(name)}
  </div>
);

export default Avatar;
